import React, { Component, Fragment } from "react";
import { functions } from "firebase";

const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export class PreRegisterPage2 extends Component {
  state = {
    entries: [],
    registered: [],
    sending: false,
    finished: false
  };

  addEntry = () => {
    const entries = [...this.state.entries, {}];
    this.setState({ entries });
  };

  onEntryChange = (offset, entry) => {
    const entries = [...this.state.entries];
    entries.splice(offset, 1, entry);
    this.setState({ entries });
  };

  removeEntryAtIndex = offset => {
    const entries = [...this.state.entries];
    entries.splice(offset, 1);
    this.setState({ entries });
  };

  onSubmit = () => {
    const { entries } = this.state;
    this.setState({ sending: true });
    return preRegisterUsers(entries, user => {
      const registered = [...this.state.registered, user];
      this.setState({ registered });
    }).then(() => {
      this.setState({ finished: true });
    });
  };

  resetPage = () => {
    this.setState({
      entries: [],
      registered: [],
      sending: false,
      finished: false
    });
  };

  render() {
    return (
      <Fragment>
        {this.state.sending && !this.state.finished && (
          <div className="alert alert-info">
            A pré-registar utilizadores — faltam{" "}
            {this.state.entries.length - this.state.registered.length}
          </div>
        )}
        {this.state.finished && (
          <div className="alert alert-success">
            Foram pré-registados {this.state.registered.length} utilizadores
            <button className="btn btn-link" onClick={e => this.resetPage()}>
              Realizar mais pré-registos
            </button>
          </div>
        )}
        {!this.state.finished && (
          <form
            onSubmit={e => {
              e.preventDefault();
              this.onSubmit();
            }}
          >
            <fieldset disabled={this.state.sending}>
              <div className="clearfix mb-2">
                <div className="float-left">
                  <h4>Pré-registos a efectuar</h4>
                </div>
                <div className="float-right">
                  <button
                    className="btn btn-primary"
                    disabled={!this.state.entries.length}
                  >
                    Pré-Registar{" "}
                    <span className="badge badge-pill badge-secondary">
                      {this.state.entries.length}
                    </span>
                  </button>
                </div>
              </div>

              <Table
                entries={this.state.entries}
                onRemove={this.removeEntryAtIndex.bind(this)}
                onEntryChange={this.onEntryChange.bind(this)}
              />
              <button
                className="btn btn-primary"
                onClick={e => this.addEntry()}
              >
                +
              </button>
            </fieldset>
          </form>
        )}
      </Fragment>
    );
  }
}

const Table = ({ entries, onRemove, onEntryChange }) => (
  <table className="table small">
    <thead>
      <tr>
        <td>Email</td>
        <td>Empresa</td>
        <td>Sector</td>
        <td>Remover</td>
      </tr>
    </thead>
    <tbody>
      {entries.map(({ contactEmail, companyId, sectorId }, offset) => (
        <tr key={offset}>
          <td>
            <EmailInput
              value={contactEmail}
              onChange={contactEmail =>
                onEntryChange(offset, { contactEmail, companyId, sectorId })
              }
            />
          </td>
          <td>
            <TextInput
              value={companyId}
              onChange={companyId =>
                onEntryChange(offset, { contactEmail, companyId, sectorId })
              }
            />
          </td>
          <td>
            <SectorSelect
              value={sectorId}
              onChange={sectorId =>
                onEntryChange(offset, { contactEmail, companyId, sectorId })
              }
            />
          </td>
          <td>
            <button
              className="btn btn-link text-danger"
              onClick={onRemove.bind(this, offset)}
            >
              x
            </button>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);

const TextInput = ({ placeholder, value = "", onChange }) => (
  <input
    type="text"
    className="form-control form-control-sm"
    required
    placeholder={placeholder}
    value={value}
    onChange={e => onChange(e.target.value)}
  />
);

const EmailInput = ({ placeholder, value = "", onChange }) => (
  <input
    type="email"
    className="form-control form-control-sm"
    required
    placeholder={placeholder}
    value={value}
    onChange={e => onChange(e.target.value)}
  />
);

const SectorSelect = ({ value, onChange }) => (
  <select
    className="form-control form-control-sm"
    required
    onChange={e => onChange(e.target.value)}
    value={value}
  >
    <option value="">Seleccione Sector</option>
    <option value="agro">AgroIndustrial</option>
    <option value="metal">Metalomecânica</option>
    <option value="transports">Transportes e Logística</option>
    <option value="waste">Ambiente e Resíduos</option>
  </select>
);

const preRegisterUsers = (users, afterEachFn) => {
  return users.reduce((previous, user) => {
    return previous.then(() => {
      console.log(`preregistering '${user.contactEmail}'`);
      return functions()
        .httpsCallable("preRegisterUsers")({
          ...user
        })
        .then(() => afterEachFn && afterEachFn(user));
    });
  }, Promise.resolve());
};

const EmailForm = ({ active, onChange, onSubmit, result }) => {
  return (
    <form
      onSubmit={e => {
        e.preventDefault();
        onSubmit();
      }}
    >
      <fieldset disabled={!active}>
        <textarea
          className="form-control mb-2"
          cols="30"
          rows="10"
          onChange={e => onChange(e.target.value)}
        />
        <button className="btn btn-primary">Enviar</button>
      </fieldset>
    </form>
  );
};

const EmailStatus = ({ validEmails, nonValidEmails }) => {
  return (
    <div>
      <div className="mb-4">
        {validEmails && validEmails.length > 0 && (
          <Fragment>
            <div className="alert alert-success">
              {validEmails.length} emails válidos
            </div>
            <div>
              {validEmails.map(email => (
                <span
                  key={email}
                  className="badge badge-pill badge-success mr-2"
                >
                  {email}
                </span>
              ))}
            </div>
          </Fragment>
        )}
      </div>
      <div>
        {nonValidEmails && nonValidEmails.length > 0 && (
          <Fragment>
            <div className="alert alert-danger">
              {nonValidEmails.length} emails inválidos
            </div>
            <div>
              {nonValidEmails.map(email => (
                <span
                  key={email}
                  className="badge badge-pill badge-danger mr-2"
                >
                  {email}
                </span>
              ))}
            </div>
          </Fragment>
        )}
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/PreRegister2.jsx